import { useMediaQuery } from "react-responsive";

import { Operation } from "./types";

export const isProduction = process.env.REACT_APP_ENV === "production";

const host = process.env.REACT_APP_API_HOST || "localhost";
const port = process.env.REACT_APP_API_PORT || 3000;
export const API_CALL_URL = isProduction ? `https://${host}/api` : `http://${host}:${port}/api`;

export const PAGE_TITLE = {
  ContentsListPage: "コンテンツ一覧",
  CategoryListPage: "カテゴリ一覧",
  TagListPage: "タグ一覧",
  PositionListPage: "ポジション一覧",
  ReferenceListPage: "参照元一覧",
  AffiliateListPage: "アフィリエイト一覧",
};

export const OPERATION_NAME = {
  CREATE: "create" as Operation,
  EDIT: "edit" as Operation,
  DELETE: "delete" as Operation,
};

export const getScreenWidth = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });
  const isTablet = useMediaQuery({ query: "(min-width: 501px) and (max-width: 1199px)" });
  const isDesktop = useMediaQuery({ query: "(min-width: 1200px)" });
  const isTwoColumn = useMediaQuery({ query: "(min-width: 800px)" });

  return { isMobile, isTablet, isDesktop, isTwoColumn };
};
